import {useParams} from "react-router-dom"

export function useCustomerID(): string {
	const {id} = useParams()
	return id!
}
